export default {
  columnOptions: "Column Options",
  rowsPerPage: "Rows per page",
  search: "Search",
};
